import { IsNullOrEmpty } from '.';
const commonErrorMessage = 'Une erreur est survenue.';
export const getError = (error) => {
    var _a;
    if (IsNullOrEmpty(error))
        return commonErrorMessage;
    return (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
};
export const getErrorMessage = (error) => {
    var _a;
    if (!error)
        return commonErrorMessage;
    return (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.Details.errors[0].message;
};
